import requests from '@/utils/requests';

/**
 * 评估任务查询接口
 * @param {*} data
 */
export function assessTaskQuery(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/assessTaskQuery',
    method: 'post',
    data
  });
}

/**
 * 评估任务保存接口
 * @param {*} data
 */
export function assessTaskSave(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/assessTaskSave',
    method: 'post',
    data
  });
}

/**
 * 工作量确认保存接口
 * @param {*} data
 */
export function assessTaskConfirm(data) {
  return requests({
    serviceName: 'devops-services',
    url: '/v1/business/assessTaskConfirm',
    method: 'post',
    data
  });
}
